import axios from "axios";

export const URL_API = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : "https://advance-v2.storage.dpe.cloud/api";
export const instance = axios.create({
  withCredentials: true,
  baseURL: URL_API,
});
